import React, {useEffect, useState} from 'react';
import {useEnvironment, useExperiments, WidgetProps} from '@wix/yoshi-flow-editor';
import {ONE_COLUMN_VIEW_WIDTH_THRESHOLD} from '../../Checkout/constants';
import {PaymentRequestControllerProps} from '../../../types/paymentRequestApp.types';
import {SPECS} from '../../../common/constants';

type VoidReturn<T> = T extends (...args: infer P) => unknown ? (...args: P) => void : T;
type VoidMethodsDeep<T extends Record<string, unknown>> = {
  [K in keyof T]: T[K] extends Record<string, unknown> ? VoidMethodsDeep<T[K]> : VoidReturn<T[K]>;
};
export type UseControllerPropsResult = WidgetProps<VoidMethodsDeep<PaymentRequestControllerProps>>;

const Context = React.createContext({} as WidgetProps<PaymentRequestControllerProps>);

export function useControllerProps(): UseControllerPropsResult {
  return React.useContext(Context);
}

export function ControllerContext({
  value,
  children,
}: {
  value: WidgetProps<PaymentRequestControllerProps>;
  children: React.ReactNode;
}) {
  const {isMobile} = useEnvironment();
  const {experiments} = useExperiments();
  const useIsMobileForOneColumnView = experiments.enabled(SPECS.UseIsMobileForOneColumnView);

  const [isOneColumnView, setIsOneColumnView] = useState<boolean>(false);
  useEffect(
    () => {
      if (useIsMobileForOneColumnView) {
        return;
      }
      const handleResize = () => {
        setIsOneColumnView(window?.innerWidth <= ONE_COLUMN_VIEW_WIDTH_THRESHOLD);
      };
      handleResize();
      window?.addEventListener('resize', handleResize);
      return () => {
        window?.removeEventListener('resize', handleResize);
      };
    },
    /* eslint-disable react-hooks/exhaustive-deps*/ []
  );

  const resolvedIsOneColumnView = useIsMobileForOneColumnView ? isMobile : isOneColumnView;

  return <Context.Provider value={{...value, isOneColumnView: resolvedIsOneColumnView}}>{children}</Context.Provider>;
}
